module.exports = __webpack_public_path__ + "assets/img/third.1fdf78b3.png";